import React from 'react';
import type {FCWithChildren} from 'types';

const SceneSubMenuName = 'SceneSubMenu';

const SceneSubMenu: FCWithChildren = ({children}) => {
  return <>{children}</>;
};

SceneSubMenu.displayName = SceneSubMenuName;

export {SceneSubMenu, SceneSubMenuName};
